import { render, staticRenderFns } from "./salesBigCustomers.vue?vue&type=template&id=c8cff1f2&scoped=true&"
import script from "./salesBigCustomers.vue?vue&type=script&lang=js&"
export * from "./salesBigCustomers.vue?vue&type=script&lang=js&"
import style0 from "./salesBigCustomers.vue?vue&type=style&index=0&id=c8cff1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cff1f2",
  null
  
)

export default component.exports